import moment from 'moment'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { isEnterpriseSelector } from 'features/billing'

const SMS_CUSTOMIZATION_RESTRICTION_DAYS = 60

export const useIsSmsCustomizationRestricted = (currentUser) => {
  const isEnterprise = useSelector(isEnterpriseSelector)

  return useMemo(() => {
    if (isEnterprise) return false
    if (!currentUser?.created_at) return false

    const today = moment().startOf('day')
    const createdAt = moment(currentUser.created_at).startOf('day')

    return today.subtract(SMS_CUSTOMIZATION_RESTRICTION_DAYS, 'days').isBefore(createdAt)
  }, [currentUser, isEnterprise])
}
